import axios from '@/server/axios'
//查询专利
export function queryPatent(params) {
    return axios({
        url: 'officialWebsite/patentList',
        method: 'get',
        params: params
    })
}
//查询专利
export function patentDetail(id) {
    return axios({
        url: 'officialWebsite/patentDetail',
        method: 'get',
        params: id
    })
}
